<fieldset class="h-100 w-100 q-fieldset">
  <legend><i class="fas fa-calendar-alt"></i> Planning</legend>
  <div class="q-render h-100 w-100">
    <!--FILTRES DES RESERVATIONS-->
    <div class="d-flex flex-wrap">
      <!--DATES-->
      <div class="d-flex flex-wrap align-items-center my-2">
        <p class="my-0 mr-2" style="font-size:12px;">Filtrer : Du </p>
        <q-date class="my-1" style="width:125px" (blur)="OnFilterChange()" [(ngValue)]="model.FiltreDateDebut" (isValid)="isDateDebut = $event" required></q-date>
        <p class="my-0 mx-2" style="font-size:12px;">au </p>
        <q-date style="width:125px" class="my-1" (blur)="OnFilterChange()" [(ngValue)]="model.FiltreDateFin" (isValid)="isDateFin = $event" required></q-date>
      </div>
      <!--AVATAR SEARCH-->
      <div class="d-flex align-items-center">
        <p class="mx-2 my-0" style="font-size:12px;">Formateur :</p>
        <ng-container *ngIf="utilities.isEmptyStr(identFormateur); else singleFormateur">
          <q-avatar-search [nullable]="true"
                           [elementList]="model.LstFormateur"
                           labelPropName="FullName"
                           identPropName="Ident"
                           imgPropName="Image"
                           (selectedList)="OnFormateurChange($event)"
                           multipleSelection="true">
          </q-avatar-search>
        </ng-container>
        <ng-template #singleFormateur>
          <img class="rounded-circle" style="width:30px;" [src]="model.ImgSingleFormateur" alt="ImgFormateur" />
        </ng-template>
      </div>
    </div>
    <!-- SELECTION DE TOUTE LES RESERVATIONS -->
    <div class="w-100" *ngIf="LstReservationFilter && LstReservationFilter.length > 0">
      <div class="q-check mt-2">
        <input (click)="allReservationAreSelected = !allReservationAreSelected; AddRemoveAllReservation()" type="checkbox" id="selectAllReservation" [(ngModel)]="allReservationAreSelected" />
        <label for="selectAllReservation">
          <span></span>Tout sélectionner
        </label>
      </div>
    </div>
    <div class="w-100" *ngIf="!LstReservationFilter || LstReservationFilter.length == 0">
      Aucune réservation sur cette période
    </div>
    <!--AFFICHAGE DES RESERVATIONS-->
    <div style="max-height:300px;overflow:auto" class="row no-gutters mt-2">
      <ng-container *ngFor="let reservation of LstReservationFilter;let index = index">

        <div [ngClass]="[reservation.IsSelected ? 'bold d-flex q-check align-items-center col-12 my-2' : 'd-flex q-check align-items-center col-12 my-2']" >

            <input (change)="AddRemoveReservation(reservation)" type="checkbox" [checked]="reservation.IsSelected" id="reserv{{index}}{{randomNumber}}" />
            <label for="reserv{{index}}{{randomNumber}}" class="d-flex align-items-center">
              <span style="min-width: 20px;"></span>
              <p class="my-0 mr-2" *ngFor="let formateurRattache of reservation.LstFormateurRattache">
                <img [title]="formateurRattache.FullName" src="{{formateurRattache.Image}}" onerror="this.onerror=null; this.src='assets/images/Profil.png'" loading="lazy" class="ImgUser">
              </p>
              <p class="my-0 mr-2" style="font-size:12px;">{{reservation.FullTitreDate}}</p>
            </label>
 
        </div>
      </ng-container>
    </div>
  </div>
</fieldset>
